import React from 'react';
import { Tooltip } from '@mui/material';
import { WarningAmberRounded } from '@mui/icons-material';
import { useGlobalization } from '@Translations/useGlobalization';

// The inspection columns are showing today's data because this result
// predates capture (INSPECTION_RERUN_NEEDED, I360A-3600).
export const InspectionRerunWarning = () => {
	const { t } = useGlobalization();
	const label = t(
		'Live data: inspection details were not recorded for this run. Re-run for accurate results.',
	);
	return (
		<Tooltip arrow title={label}>
			<span
				role="img"
				// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- tooltip trigger: focusable so keyboard users can reach the reason
				tabIndex={0}
				aria-label={label}
				data-cy="inspection-rerun-warning"
				style={{
					display: 'inline-flex',
					marginLeft: 4,
					verticalAlign: 'middle',
				}}>
				<WarningAmberRounded sx={{ fontSize: 14, color: '#e0872f' }} />
			</span>
		</Tooltip>
	);
};
